module.exports = __webpack_public_path__ + "img/image21.922ab24f.png";